$(() => {
    const winWidth = $(window).width();

    /*Main navigation Scroll Function*/
    if ($('.bs-section--non-transparent-header').length > 0) {
        $('header').addClass('scrollMenu');
    } else {
        $(window).on('scroll load', () => {
            var navHeight = 40;
            ($(window).scrollTop() > navHeight) ? $('header').addClass('scrollMenu') : $('header').removeClass('scrollMenu');
        });
    }

    // web only
    if ($(window).width() > 1199) {
        /*Main navigation Dropdown*/
        $('header li.menu-item-has-children').hover(
            (e) => {
                $(e.currentTarget).find('.sub-menu').show();
                $(e.currentTarget).addClass("active-item");
            },
            (e) => {
                $(e.currentTarget).find('.sub-menu').css("display", "none");
                $(e.currentTarget).removeClass("active-item");
            }
        );
    }



    const scrolling = () => {
        $("header .global-search span").removeClass("close");
        $("header .global-search span").addClass("search-box-close-icon");

        if (winWidth > 1199) {
            $("header .searchform #s").css("display", "none");
        }

        if ($(window).width() > 1199) {
            $("header .menu-item-has-children").hover(
                function () {
                    $(this).find(".dropdown-menu").fadeIn();
                    $(this).addClass("active-item");
                },
                function () {
                    if (!$(this).parent(".dropdown-menu").children('li').hasClass("menu-title")) {
                        $("header .menu-item-has-children").find(".dropdown-menu").css("display", "none");
                        $("header .menu-item-has-children").removeClass("active-item");
                    }
                    if (!$(window).scrollTop() > 0) {
                        $("header").removeClass("scrolled");
                    }
                }
            );
        }
    };
    /*Main navigation Scroll Function*/
    scrolling();
    $(window).on("scroll resize", function () {
        scrolling();
    });

    const openSearchBox = () => {
        $("header .global-search span").on("click", function () {
            if ($(this).hasClass("close")) {
                $(this).removeClass("close");
                $(this).addClass("search-box-close-icon");
                setTimeout(function () {
                    $("header #searchform #s").hide();
                }, 30);
            } else {
                $("header #searchform #s").show();
                $(this).addClass("close");
                $(this).removeClass("search-box-close-icon");
                setTimeout(function () {
                    $('header #searchform #s').focus()
                }, 50);
            }
        });
    }

    if (winWidth > 1199) {
        openSearchBox();
    }

    $('#expand-btn, .search-box-close-icon').on('click', function () {
        setTimeout(() => {
            $("header .global-search form input").attr("placeholder", "Let’s find what you’re looking for…");
        }, 100);
    })
    $('#expand-btn.navbar-toggler').on('click', function () {
        $("header .global-search form input").css("display", "none");
    })
    $('header, .search .searchform #searchsubmit').attr('value', '');

    //Mobile Header - Sub Menu Show-Hide Function
    $('header li.menu-item-has-children').each(function () {
        $(this).append('<span class="drop-down-helper"></span>');
    });
    let headerDropDownHelper = $('header span.drop-down-helper');
    headerDropDownHelper.on('click', function () {
        let $this = $(this);
        $this.parents('li.menu-item-has-children')
            .siblings('li.menu-item-has-children.active-menu-item').removeClass('active-menu-item').find('.sub-menu').slideUp(600)
            .find('li.menu-item-has-children.active-menu-item').removeClass('active-menu-item').find('.sub-menu').slideUp(600);
        $this.prev('.sub-menu').slideToggle(600);
        $this.parent('li').toggleClass('active-menu-item');
    });

    if (winWidth < 1200) {
        if ($(".global-search").length > 0) {
            $(".navbar").append($(".global-search"));
        }
    }

    $('header #searchform #s').bind("keyup keypress", function (e) {
        let code = e.keyCode || e.which;
        if (code == 13) {
            if ($(this).val().trim() == '') {
                e.preventDefault();
                return false;
            }
        }
    });

    $('.global-search span.search-box-close-icon').click(() => {
        $('body').addClass('mobile-serach');
        $("header .global-search .searchform #s").css("display", "block");
        $("header #expand-btn").css("display", "none");
    });

    $('.global-search span.close-icon').click(() => {
        $('body').removeClass('mobile-serach');
        $("header .global-search .searchform input").css("display", "none");
        $("header #expand-btn").css("display", "block");
    });

    $('.navbar-toggler').click(() => {
        $('body').toggleClass('mobile-open');
        $("body.mobile-open header .global-search .searchform #s").css("display", "block");
    });

    if ($('.bs-section--transparent-header').length > 0) {
        $('main').addClass('transparent-header');
    }

});
